export enum ESalutation {
  MALE = 'male',
  FEMALE = 'female',
  DIVERS = 'unknown',
}
